type EventTarget = Window | Document | HTMLElement;

export function on<T extends HTMLElement, K extends keyof HTMLElementEventMap>(
  target: T,
  type: K,
  handler: (this: T, ev: HTMLElementEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions,
): () => void;
export function on<K extends keyof DocumentEventMap>(
  target: Document,
  type: K,
  handler: (this: Document, ev: DocumentEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions,
): () => void;
export function on<K extends keyof WindowEventMap>(
  target: Window,
  type: K,
  handler: (this: Window, ev: WindowEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions,
): () => void;
export function on(
  target: EventTarget,
  type: string,
  handler: EventListenerOrEventListenerObject,
  options: boolean | AddEventListenerOptions = {},
) {
  target.addEventListener(type, handler as any, options);
  return () => target.removeEventListener(type, handler as any, options as any);
}

export function off<T extends HTMLElement, K extends keyof HTMLElementEventMap>(
  target: T,
  type: K,
  handler: (this: T, ev: HTMLElementEventMap[K]) => any,
  options?: boolean | EventListenerOptions,
): void;
export function off<K extends keyof DocumentEventMap>(
  target: Document,
  type: K,
  handler: (this: Document, ev: DocumentEventMap[K]) => any,
  options?: boolean | EventListenerOptions,
): void;
export function off<K extends keyof WindowEventMap>(
  target: Window,
  type: K,
  handler: (this: Window, ev: WindowEventMap[K]) => any,
  options?: boolean | EventListenerOptions,
): void;
export function off(
  target: EventTarget,
  type: string,
  handler: EventListenerOrEventListenerObject,
  options?: boolean | EventListenerOptions,
) {
  target.removeEventListener(type, handler as any, options as any);
}

export enum MouseButton {
  LEFT = 0,
  MIDDLE = 1,
  RIGHT = 2,
}

export function once<T extends HTMLElement, K extends keyof HTMLElementEventMap>(
  target: T,
  type: K,
  handler: (this: T, ev: HTMLElementEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions,
): () => void;
export function once<K extends keyof DocumentEventMap>(
  target: Document,
  type: K,
  handler: (this: Document, ev: DocumentEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions,
): () => void;
export function once<K extends keyof WindowEventMap>(
  target: Window,
  type: K,
  handler: (this: Window, ev: WindowEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions,
): () => void;
export function once(
  target: EventTarget,
  type: string,
  handler: EventListenerOrEventListenerObject,
  options: boolean | AddEventListenerOptions = {},
) {
  // @ts-expect-error skip check
  const dispose = on(
    target,
    type,
    function (this: any, ev: Event) {
      if (typeof handler === 'function') {
        handler.call(this, ev);
      } else {
        handler.handleEvent(ev);
      }
      dispose();
    },
    options,
  );

  return dispose;
}
